module.exports = {
  siteTitle: 'Ram Kartikeya Boyini (@thekinggpin)',
  siteDescription:
    'Ram Kartikeya Boyini, is a Senior Software Engineer, from New York, USA.',
  siteKeywords:
    'Ram Kartikeya,ram kartikeya boyini,Boyini,ram kartikeya,Kartikeya,Ram, thekinggpin,software engineer,Computer Science Engineer, java engineer,java,python engineer,new york engineer',
  siteUrl: 'https://ramkartikeya.com',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-173664694-1',
  googleVerification: 'zy9hLz1o42crLIOdR97fCJYYmTJJ0KoOX0E_fgPQKRI',
  name: 'Ram Kartikeya',
  location: 'New York, USA',
  email: 'boyini.r@outlook.com',
  github: 'https://github.com/thekinggpin',
  twitterHandle: '@thekinggpin',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/thekinggpin',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/ramkartikeya',
    },
    {
      name: 'Behance',
      url: 'https://www.behance.net/ramkartikeya',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/thekinggpin',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/thekinggpin',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
